import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=0381b730"
import script from "./PolicyList.vue?vue&type=script&lang=js"
export * from "./PolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports